import { _ as _assocIndexOf } from "./auth-service-tools1292.js";
var assocIndexOf = _assocIndexOf;

function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

var _listCacheHas = listCacheHas;
export { _listCacheHas as _ };